import { createTheme } from '@mui/material';

const colors = {
  neutral: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#e5e5e5',
    300: '#d4d4d4',
    400: '#a3a3a3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
    950: '#0a0a0a',
  },
};

// shad/cn カレーパレット
// https://ui.shadcn.com/colors#colors

// shad/cn テーマ
// https://ui.shadcn.com/docs/theming

export const themeLight = createTheme({
  palette: {
    mode: 'light',
    grey: colors.neutral,
    common: {
      black: '#171717', // oklch(.205 0 0)
      white: '#ffffff',
    },
    primary: {
      main: '#171717', // oklch(.205 0 0)
    },
    secondary: {
      //   main: '#f5f5f5', // oklch(0.97 0 0)
      // TODO: muiとshad/cnでsecondaryの扱いが異なるので、一旦primaryと合わせる
      main: '#171717', // oklch(.205 0 0)
    },
    background: {
      default: '#ffffff', // oklch(1 0 0)
      paper: '#fafafa', // oklch(.985 0 0)
    },
    error: {
      main: '#e7000b', // oklch(0.577 0.245 27.325)
    },
  },
});

export const themeDark = createTheme({
  palette: {
    mode: 'dark',
    grey: colors.neutral,
    common: {
      black: '#171717', // oklch(.205 0 0)
      white: '#ffffff',
    },
    primary: {
      main: '#e5e5e5', // oklch(0.922 0 0)
    },
    secondary: {
      //   main: '#262626', // oklch(0.269 0 0)
      main: '#e5e5e5', // oklch(0.922 0 0)
    },
    background: {
      default: '#0a0a0a', // oklch(0.145 0 0)
      paper: '#171717', // oklch(.205 0 0)
    },
    error: {
      main: '#ff6467', // oklch(0.704 0.191 22.216)
    },
  },
});
